import { useContext } from 'react'
import FeatureFlagContext, { IFeatureFlagContextType } from 'services/FeatureFlags/context'

const useFeatureFlagContext = (): IFeatureFlagContextType => useContext(FeatureFlagContext)

export default useFeatureFlagContext
